import { IconButton } from 'office-ui-fabric-react/lib/Button';
import { CommandBar } from 'office-ui-fabric-react/lib/CommandBar';
import { ConstrainMode, DetailsList, SelectionMode } from 'office-ui-fabric-react/lib/DetailsList';
import { ScrollablePane, ScrollbarVisibility } from 'office-ui-fabric-react/lib/ScrollablePane';
import { SearchBox } from 'office-ui-fabric-react/lib/SearchBox';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { Sticky, StickyPositionType } from 'office-ui-fabric-react/lib/Sticky';
import React, { Component, Fragment } from 'react';
import { DataNotificationPush } from '../../data/DataNotificationPush';
import { Immocom } from '../../specifique/immocom';
import { FicheNotificationPush } from '../Fiche/FicheNotificationPush';
import { FicheSocietes } from '../Fiche/FicheSocietes';
import { ProgressIndicatorChargement } from '../Loader/ProgressIndicatorChargement';
import { MessageBars } from '../Outils/MessageBars';

/*
**********************************************************************************************************************
PROPS :
    ATTRIBUTS :
        -
    METHODES :
        -
**********************************************************************************************************************
*/

export class DetailsListNotificationPush extends Component {

    static defaultProps = {};

    constructor(props) {
        super(props);
        this._columns = this._getColumns();
        this._filtres = {};
        this._isSortedDescending = false;
        this._sortedColumn = "nomNotificationPush";
        this._objetState = {
            items: [],
            itemActif: {},
            /* --- */
            hideMessageBarFiltres: true,
            hideMessageBarWarning: true,
            hideMessageBarError: true
        };
        this.state = { ... this._objetState };
    };

    _creationContent = () => {
        return <DetailsList
            columns={this._columns}
            constrainMode={ConstrainMode.unconstrained}
            items={this.state.items}
            onColumnHeaderClick={this._onClickColumnHeader}
            onRenderDetailsHeader={this._onRenderDetailsHeader}
            selectionMode={SelectionMode.none}
        />
    };

    _chargementDonnees = () => {
        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: "Chargement des notifications push en cours..."
        });

        let chargementNotificationsPush = DataNotificationPush._chargementNotificationsPush(this._filtres, this._sortedColumn, this._isSortedDescending);
        chargementNotificationsPush.then(responseFetch => {
            const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
            if (retourVerif === null) {
                const listeNotificationsPush = responseFetch.reponseAPIobjet || [];
                const stateTemp = { items: listeNotificationsPush };
                Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, stateTemp);
            }
            else {
                const stateTemp = { items: [] };
                Immocom.onTraitementErreurAvecState(this, stateTemp, retourVerif, responseFetch);
            }
        });
    };

    _getColumns = () => {
        return [
            {
                key: "idNotificationPush",
                minWidth: 20,
                maxWidth: 20,
                name: "",
                onRender: (item) => {
                    const idNotificationPush = item.idNotificationPush;
                    return <span title={idNotificationPush} className="badge badge-secondary">{idNotificationPush}</span>;
                }
            },
            {
                key: "nomNotificationPush",
                name: "Nom",
                minWidth: 250,
                maxWidth: 250,
                onRender: (item) => {
                    const nomNotificationPush = item.nomNotificationPush;
                    return <span title={nomNotificationPush}>{nomNotificationPush}</span>;
                }
            },
            {
                key: "description",
                name: "Description",
                onRender: (item) => {
                    const description = item.description;
                    return <span title={description}>{description}</span>;
                }
            },
            {
                iconName: null,
                isIconOnly: true,
                key: "display",
                minWidth: 25,
                maxWidth: 25,
                name: "Afficher les sociétés abonnées à cette notification push",
                onRender: (item) => {
                    return <IconButton
                        iconProps={{ iconName: "Lock" }}
                        onClick={this._togglePanel("Societes", true, item, false)}
                        title="Afficher les sociétés abonnées à cette notification push"
                    />;
                }
            },
            {
                iconName: null,
                isIconOnly: true,
                key: "edit",
                minWidth: 25,
                maxWidth: 25,
                name: "Consulter/modifier la notification push",
                onRender: (item) => {
                    return <IconButton
                        iconProps={{ iconName: "Edit" }}
                        onClick={this._togglePanel("NotificationPush", true, item, false)}
                        title="Consulter/modifier la notification push"
                    />;
                }
            }
        ];
    };

    _getFarItems = () => {
        return [{
            key: "nombreEnregistrement",
            name: this.state.items.length
        }];
    };

    _getItems = () => {
        return [
            {
                key: "search",
                onRender: () => <SearchBox
                    className="searchBox"
                    onClear={(ev) => this._onSearch("")}
                    onSearch={(newValue) => this._onSearch(newValue)}
                    placeholder="Recherche rapide"
                />
            }
        ];
    };

    _onClickColumnHeader = (ev, column) => {
        const key = column.key;
        const isSortedDescending = !(column.isSortedDescending || false)

        this._columns.forEach((col) => {
            if (col.key === key) {
                col.isSortedDescending = isSortedDescending;
                col.isSorted = true;
            } else {
                col.isSorted = false;
                col.isSortedDescending = false;
            }
        });

        this._sortedColumn = key;
        this._isSortedDescending = isSortedDescending;
        this._chargementDonnees();
    };

    _onRenderDetailsHeader = (props, defaultRender) => {
        return <Sticky stickyPosition={StickyPositionType.Header} isScrollSynced={true}>
            {defaultRender(props)}
        </Sticky>
    };

    _onSearch = (keyword) => {
        this._filtres.recherche = keyword;
        this._chargementDonnees();
    };

    _togglePanel = (nomPanel, isOpen, item, rechargerLesDonnees) => () => {
        this.setState(
            {
                [`afficherPanel${nomPanel}`]: isOpen,
                itemActif: item || {}
            },
            rechargerLesDonnees ? this._chargementDonnees : null
        );
    };

    componentDidMount = () => { this._chargementDonnees(); };

    render = () => {

        const content = this._creationContent();
        const { itemActif, afficherPanelNotificationPush, afficherPanelSocietes } = this.state;
        const { idNotificationPush } = itemActif;

        return <Fragment>

            {this.state.enCoursDeTraitement ? <ProgressIndicatorChargement label={this.state.messageEnCoursTraitement} /> : null}

            <Stack verticalFill>
                <CommandBar
                    ariaLabel={"Utiliser les flèches droite et gauche pour naviguer"}
                    farItems={this._getFarItems()}
                    items={this._getItems()}
                    overflowButtonProps={{ ariaLabel: 'Plus de fonctionnalités' }}
                />
                <MessageBars
                    errorMessage={this.state.errorMessage}
                    infoMessage={this.state.messageMessageBarFiltres}
                    warningMessage={this.state.warningMessage}
                    onDismissErrorMessage={() => this.setState({ errorMessage: "" })}
                    onDismissWarningMessage={() => this.setState({ warningMessage: "" })}
                />
                <div className="position-relative h-100">
                    <ScrollablePane scrollbarVisibility={ScrollbarVisibility.auto}>
                        {content}
                    </ScrollablePane>
                </div>
            </Stack>

            <FicheNotificationPush
                {...itemActif}
                isOpen={afficherPanelNotificationPush}
                onDismiss={this._togglePanel("NotificationPush", false, null, false)}
                onMiseAJour={this._togglePanel("NotificationPush", false, null, true)}
            />

            <FicheSocietes
                headerText={`Sociétés abonnées à la notification push « ${itemActif.nomNotificationPush} »`}
                idNotificationPush={idNotificationPush}
                isOpen={afficherPanelSocietes}
                onDismiss={this._togglePanel("Societes", false, null, false)}
            />

        </Fragment>;

    };

};